<script lang="ts">
  import { location } from 'svelte-spa-router';

  const navItems = [
    { path: '/edit/wordbanks', label: 'Wordbanks' },
    { path: '/edit/prompts', label: 'Prompts' },
    { path: '/edit/frameworks', label: 'Frameworks' },
  ];

  $: currentPath = $location;
</script>

<nav class="editor-nav" aria-label="Editor sections">
  {#each navItems as item}
    <a
      href="#{item.path}"
      class="nav-link"
      class:active={currentPath === item.path}
      aria-current={currentPath === item.path ? 'page' : undefined}
    >
      {item.label}
    </a>
  {/each}
</nav>

<style>
  .editor-nav {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 2rem;
    background: var(--color-bg-tertiary, #fff);
    border-bottom: 1px solid var(--color-border, #ddd);
  }

  .nav-link {
    padding: 0.5rem 1rem;
    text-decoration: none;
    color: var(--color-text-secondary, #666);
    border-radius: 4px 4px 0 0;
    font-weight: 500;
    transition: all 0.2s;
    border: 1px solid transparent;
  }

  .nav-link:hover {
    background: var(--color-bg-hover, #f0f0f0);
    color: var(--color-text-primary, #333);
  }

  .nav-link:focus {
    outline: 3px solid var(--color-focus, #007bff);
    outline-offset: 2px;
  }

  .nav-link.active {
    background: var(--color-bg-primary, #fff);
    color: var(--color-primary, #007bff);
    border-color: var(--color-border, #ddd);
    border-bottom-color: transparent;
    position: relative;
    bottom: -1px;
  }
</style>
